@if (numpadInitialized$ | async) {
    @if (modeStrategy.inputMode | async; as inputMode) {
        <div
            class="stake-container"
            [ngClass]="getStakeContainerClass$ | async"
            [msStakeFontResizer]="{
                inputMode: inputMode,
                hasError: errors | async,
            }">
            @switch (inputMode) {
                @case (stakeNumpadMode.Typing) {
                    <ms-stake-input
                        class="stake-input"
                        [emptyCharacter]="emptyCharacter"
                        [disabled]="disabled"
                        [adornmentStart]="adornmentStart"
                        [behavior]="stakeInputBehavior"></ms-stake-input>
                }
                @default {
                    <ms-stake-field
                        class="stake-field"
                        [useStakeFieldCursor]="useStakeFieldCursor"
                        [emptyCharacter]="emptyCharacter"
                        [disabled]="disabled"
                        [adornmentStart]="adornmentStart"></ms-stake-field>
                }
            }
        </div>
    }
}
